export default __webpack_public_path__ + "static/day-5-27c328e962c889a6e879f52d6ef77f38.gif";